var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwooshGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55061 17.5734C9.41728 17.5734 9.29228 17.5524 9.17561 17.5104C9.05894 17.4684 8.95061 17.3978 8.85061 17.2984L4.55061 12.9984C4.36728 12.8151 4.27961 12.5774 4.28761 12.2854C4.29561 11.9934 4.39161 11.7561 4.57561 11.5734C4.75894 11.3901 4.99228 11.2984 5.27561 11.2984C5.55894 11.2984 5.79228 11.3901 5.97561 11.5734L9.55061 15.1484L18.0256 6.67344C18.2089 6.4901 18.4466 6.39844 18.7386 6.39844C19.0306 6.39844 19.2679 6.4901 19.4506 6.67344C19.6339 6.85677 19.7256 7.09444 19.7256 7.38644C19.7256 7.67844 19.6339 7.91577 19.4506 8.09844L10.2506 17.2984C10.1506 17.3984 10.0423 17.4694 9.92561 17.5114C9.80894 17.5534 9.68394 17.5741 9.55061 17.5734Z",
    fill: "#0FA44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwooshGreenIcon);
export default __webpack_public_path__ + "static/media/swoosh-green-icon.b52e325660e890ea75de6db8eca0e7a0.svg";
export { ForwardRef as ReactComponent };